import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  { src: "./img/svatby/svatby-17.jpg", alt: "Venkovní svatební obřad – dřevěný oblouk s květinovou výzdobou a lavice pro hosty" },
  { src: "./img/svatby/svatby-8.jpg", alt: "Svatební tabule s bílými ubrusy, zelenými ubrousky a květinovou výzdobou" },
  { src: "./img/svatby/svatby-22.jpg", alt: "Místa pro nevěstu a ženicha se jmenovkami a květinovou girlandou" },
  { src: "./img/svatby/svatby-11.jpg", alt: "Hospůdka pod Rablinů zvenku se svatebními koktejlovými stolky na trávníku" },
  { src: "./img/svatby/svatby-12.jpg", alt: "Detail svatebního prostírání se sklenkami prosecca a jmenovkou Maminka nevěsty" },
  { src: "./img/svatby/svatby-24.jpg", alt: "Dlouhá svatební tabule v sále s krbem, květinami a svícny" },
  { src: "./img/svatby/svatby-10.jpg", alt: "Svatební hosté na zahradě před venkovním pódiem" },
  { src: "./img/svatby/svatby-16.jpg", alt: "Slavnostně prostřená tabule s krémovým běhounem, svícny a menu kartami" },
  { src: "./img/svatby/svatby-15.jpg", alt: "Detail prostírání se svatebním menu, lučními květinami a karafou s limonádou" },
  { src: "./img/svatby/svatby-13.jpg", alt: "Svatební tabule s tmavě zeleným tylem, růžemi a bílým porcelánem" },
  { src: "./img/svatby/svatby-9.jpg", alt: "Pohled přes okrasnou zahradu na svatební hosty na louce" },
  { src: "./img/svatby/svatby-19.jpg", alt: "Váza s lučními květinami a sklenky se jmenovkami na svatební tabuli" },
  { src: "./img/svatby/svatby-23.jpg", alt: "Prostírání nevěsty – mušlový talíř, lněný ubrousek a svatební menu" },
  { src: "./img/svatby/svatby-14.jpg", alt: "Večerní svatební tabule se zeleným tylem a nazdobeným porcelánem" },
  { src: "./img/svatby/svatby-18.jpg", alt: "Detail svatebního prostírání se jmenovkou, sklenkou a menu" },
  { src: "./img/svatby/svatby-20.jpg", alt: "Svatební tabule se svícnem, lučními květinami a karafou s citrusy" },
  { src: "./img/svatby/svatby-25.jpg", alt: "Prostírání ženicha s lněným ubrouskem a svatebním menu" },
  { src: "./img/svatby/svatby-26.jpg", alt: "Večerní svatební tabule nasvícená svícny s růžovými svíčkami" },
  { src: "./img/svatby/svatby-21.jpg", alt: "Detail večerní svatební tabule se sklenkou, karafou a jmenovkou" },
  { src: "./img/svatby.jpg", alt: "Svatební hostina v Hospůdce pod Rablinů" },
  { src: "./img/svatby-venku-1.jpg", alt: "Venkovní svatba na zahradě Hospůdky pod Rablinů" },
  { src: "./img/svatba-rablina-exterior-1.jpg", alt: "Svatební prostory v exteriéru Hospůdky pod Rablinů" },
  { src: "./img/grillovani.webp", alt: "Grilování a venkovní občerstvení pro svatební hosty" },
  { src: "./img/exterier/exterier-4.jpg", alt: "Exteriér a zahrada Hospůdky pod Rablinů" },
];

const FotogalerieSvatbyDesktop: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Svatby | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie svateb v Hospůdce pod Rablinů – svatební atmosféra, venkovní prostory a zázemí."
        />
      </Helmet>

      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            SVATBY
          </h1>
        </section>

        <section className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((img) => (
              <img
                key={img.src}
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        <div className="[all:unset] block">
          <Footer />
        </div>
      </main>
    </>
  );
};

export default FotogalerieSvatbyDesktop;
